export default "<p>\r\n  loader works!\r\n</p>\r\n"